// extracted by mini-css-extract-plugin
export var animationContainer = "_e4-0";
export var asteriskIcon = "_e4-8";
export var conversationLeftSection = "_e4-4";
export var conversationListItem = "_e4-3";
export var conversationMiddleSection = "_e4-5";
export var conversationRightSection = "_e4-6";
export var detailsContent = "_e4-1";
export var listContainer = "_e4-7";
export var modalContent = "_e4-2";